import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from "react-hook-form";
import ErrorMessage from './ErrorMessage';

const TextInput= ({name, type='text', placeholder, ...others}) => {
  const { control} = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field, //{ onChange, onBlur, value, name, ref }
        fieldState: { invalid, isTouched, isDirty, error },
        formState,
      }) => (
        <div className="mb-3">
          <div className="form-floating">
            <input
              {...field}
              id={field.name}
              type={type}
              className={`form-control rounded-0 ${isTouched && invalid ? "is-invalid" : ""}`}
              placeholder={placeholder}
              {...others}
            />
            <label htmlFor={field.name}>{placeholder}</label>
          </div>
          <ErrorMessage error={error}/>
        </div>
      )}
    />
  )
}

TextInput.defaultProps = {};

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string,
};

export default TextInput;